import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { User as UserIcon } from '../../shared/icons';
import { TypeDeleteConfirmationModal } from '../../shared/modal/TypeDeleteConfirmationModal';
import { getDeletingRole, deleteRoleStarted, getSelectedRole } from './store';

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ isOpen, closeModal }) => {
    const dispatch = useAppDispatch();
    const isDeleting = useAppSelector(getDeletingRole);
    const selectedRole = useAppSelector(getSelectedRole);
    const { roleId, roleName } = selectedRole;
    const deleteRole = useCallback(() => dispatch(deleteRoleStarted(roleId!)), [dispatch, roleId]);

    const headerLabel = `Delete Role ${roleName}?`;

    return (
        <TypeDeleteConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            deleteAction={deleteRole}
            isDeleting={isDeleting}
            headerLabel={headerLabel}
            name={roleName}
            testId='role'
            icon={UserIcon}
            warning='Once deleted, all users with this role will be reverted back to a basic user'
        />
    );
};
